import { Action, LoadingState, LoadingStateStatus } from 'shared/interface';

const ActionTypeToRequestStateMap: Record<string, LoadingStateStatus> = {
	INIT: 'LOADING',
	SUCCESS: 'SUCCESS',
	FAIL: 'FAIL',
};

const loadingReducer = (state: LoadingState = { api: {} }, action: Action): LoadingState => {
	const { type } = action;
	const matches = /(.*)_(INIT|SUCCESS|FAIL)/.exec(type);

	// not a *INIT / *_SUCCESS /  *_FAIL actions, so we ignore them
	if (!matches) {
		return state;
	}

	const [, requestName, requestState] = matches;
	return {
		...state,
		api: {
			...state.api,
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			[requestName!]: ActionTypeToRequestStateMap[requestState!]!,
		},
	};
};

export default loadingReducer;
